/**
 * 设备信息组件
 */
// import Core from '@/libs/src/core.js'
import { Style } from '@/libs/style.js';

// 获取数据处理层的provider
let DPC = null//Core.getProvider('DPC');
let modules = null // DPC.modules;

let template = /*html*/ `<div class="app-monitoring">
    <div class="app-monitoring-header">
        <img src="./images/default/2.png" alt="">
        <h2>基本资料</h2>
        <dv-decoration-1 style="width:200px;height:100%;position:absolute;right:0;" />
    </div>
    <dv-decoration-4 :color="['#2bbde9']" :reverse="true" style="width:100%;height:5px;" />
    <dv-scroll-board-1 :config="JSON.stringify(config)" ></dv-scroll-board-1>
</div>`;


let style = /* css */ `.app-monitoring{
    position: absolute;
    top: 10%;
    left: 1%;
    width: 25%;
    background: transparent;
    height: 30%;
    overflow: hidden;
    z-index:2;
    pointer-events:none;
    background:rgba(0,0,0,.5)
}

.app-monitoring .app-monitoring-header{
    background:linear-gradient(to right,#159AFF,rgba(0,0,0,0) 100%);
    height: 50px;
    color: #fff;
    display:flex;
    align-items:center;
    position:relative;
}
.app-monitoring .app-monitoring-header img{
    margin:0 15px;
}
`;

export default (Vue) => {
    Vue.customElement('xbt-device-monitoring', {
        template: template,
        data() {
            return {
                config: {
                    oddRowBGC: 'rgba(0,0,0,0)',
                    evenRowBGC: 'rgba(0,0,0,0)',
                    data: [
                        ['系统湿度',/* html */`<div style="text-align: right;width:100%;display:flex;align-items:center;"><div style="width:120px;margin-right:15px;">45%</div><img style="width:25px;height:25px;" src="/images/xbt/253.png" /></div>`],
                        ['系统温度',/* html */`<div style="text-align: right;width:100%;display:flex;align-items:center"><div style="width:120px;margin-right:15px;">33℃</div><img style="width:25px;height:25px;" src="/images/xbt/253.png" /></div>`],
                        ['瞬时流量',/* html */`<div style="text-align: right;width:100%;display:flex;align-items:center"><div style="width:120px;margin-right:15px;">3230m³</div><img style="width:25px;height:25px;" src="/images/xbt/255.png" /></div>`],
                        ['累计流量',/* html */`<div style="text-align: right;width:100%;display:flex;align-items:center"><div style="width:120px;margin-right:15px;">108542m³</div><img style="width:25px;height:25px;" src="/images/xbt/255.png" /></div>`],
                        ['当前功率',/* html */`<div style="text-align: right;width:100%;display:flex;align-items:center"><div style="width:120px;margin-right:15px;">2518W</div><img style="width:25px;height:25px;" src="/images/xbt/257.png" /></div>`],
                        ['当前电能',/* html */`<div style="text-align: right;width:100%;display:flex;align-items:center"><div style="width:120px;margin-right:15px;">521KwH</div><img style="width:25px;height:25px;" src="/images/xbt/257.png" /></div>`]
                    ],
                    align: ['center'],

                }
            }
        },
        created() {
            DPC = this.$Core.getProvider('DPC');
            modules = DPC.modules;
            if (!modules) {
                DPC.proc.watch('modules', (val) => {
                    let monitor = val.filter(item => item.showType === 'monitor' || item.showType === 'enum');
                    this.setList(monitor)
                })
            } else {
                let monitor = modules.filter(item => item.showType === 'monitor' || item.showType === 'enum');
                this.setList(monitor)
            }
        },
        mounted() {
            Style(style);
        },
        methods: {
            setList(val) {

                val.forEach(item => {
                    let unit = item.unit.length > 1 ? item.unit[1] : '';
                    let displayValue = Number(item.displayValue) ? Number(item.displayValue).toFixed(2) : item.displayValue;
                    let itemArr = [item.controlName, `<div style="text-align: right;width:100%;">${displayValue} ${unit}</div>`];
                    // this.config.data.push(itemArr)
                })
            }
        }
    });
}